import type { ReactElement } from 'react';
import { memo, useMemo } from 'react';

import { OperationHistory } from '@/components/common/OperationHistory';

import { useNoteHistoryQuery } from '../hooks/useNoteHistoryQuery';

import { mapNoteEvent, useNoteHistoryConfig } from './noteHistoryConfig';

interface NoteHistoryProps {
  noteId: string;
}

export const NoteHistory = memo(function NoteHistory({
  noteId,
}: NoteHistoryProps): ReactElement {
  const { events, isLoading } = useNoteHistoryQuery(noteId);
  const config = useNoteHistoryConfig();
  const mappedEvents = useMemo(() => events.map(mapNoteEvent), [events]);

  return (
    <OperationHistory
      events={mappedEvents}
      config={config}
      showFilters
      isLoading={isLoading}
    />
  );
});
